import { useState } from "react"
import { JobbinSecondaryButtonProps } from "./model"

export const JobbinSecondaryButton = (props: JobbinSecondaryButtonProps) => {
    const [pending, setPending] = useState(false)
    const busy = pending || props.loading
    const isDisabled = busy || props.disabled

    const handleClick = async () => {
        if (isDisabled || !props.onClickAction) return
        const result = props.onClickAction()
        if (result && typeof (result as Promise<void>).then === "function") {
            try {
                setPending(true)
                await result
            } finally {
                setPending(false)
            }
        }
    }

    return (
        <div className="w-full">
            <button
                className="jobbin-primary-button flex items-center justify-center gap-2 py-[16px] px-[32px] bg-white outline outline-offset-[-3px] outline-figmaPrimary text-figmaBlack w-full transition disabled:cursor-not-allowed disabled:opacity-60"
                onClick={handleClick}
                disabled={isDisabled}
            >
                {busy && (
                    <span className="h-5 w-5 animate-spin rounded-full border-2 border-figmaPrimary border-t-transparent" />
                )}
                {props.text}
            </button>
        </div>
    )
}